import React, { useState, useRef, useEffect } from 'react';
import "../process/process.css";
import rightarrow from '../../images/arrow right.svg';
import titleArrow from '../../images/Vector 6.png';
import { FaArrowDownLong } from "react-icons/fa6";
import { FaArrowUpLong } from "react-icons/fa6";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

import { ReactComponent as Procesimg1 } from '../../images/procesimg1.svg'
import { ReactComponent as Procesimg2 } from '../../images/procesimg2.svg'
import { ReactComponent as Procesimg3 } from '../../images/procesimg3.svg'
import { ReactComponent as Procesimg4 } from '../../images/procesimg4.svg'
import { ReactComponent as Procesimg5 } from '../../images/procesimg5.svg'
import { ReactComponent as Procesimg6 } from '../../images/procesimg6.svg'
import { ReactComponent as Procesimg7 } from '../../images/procesimg7.svg'
import { ReactComponent as Procesimg8 } from '../../images/procesimg8.svg'
import { ReactComponent as Procesimg9 } from '../../images/procesimg9.svg'
import { ReactComponent as Procesimg10 } from '../../images/procesimg10.svg'
import { ReactComponent as Procesimg11 } from '../../images/procesimg11.svg'
import { ReactComponent as Procesimg12 } from '../../images/procesimg12.svg'
import { ReactComponent as Procesimg13 } from '../../images/procesimg13.svg'



function Process() {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    const [currentIndex, setCurrentIndex] = useState(0); // State to track the current visible card
    const [cardHeight, setCardHeight] = useState(0); // State to track the height of each card
    const cardRef = useRef(null); // Ref for the process card
    const intervalRef = useRef(null); // Ref for managing the auto-scroll interval
    const [activeButton, setActiveButton] = useState()

    const processdata = [
        {
            id: 1,
            title: "Expertise in Popular AR/VR Engines",
            icon: Procesimg1,
            text: "We work extensively with Unity, Unreal Engine, and WebXR frameworks, ensuring smoother development cycles for immersive experiences."
        },
        {
            id: 2,
            title: " Cross-Platform Deployment",
            icon: Procesimg2,
            text: "Whether it’s Oculus, HTC Vive, HoloLens, or mobile AR (ARKit/ARCore), we ensure your apps deliver consistent quality across devices."
        },
        {
            id: 3,
            title: "Performance & Rendering Optimization",
            icon: Procesimg3,
            text: "Real-time 3D can be demanding. We fine-tune shaders, textures, and lighting pipelines, so your visuals run smoothly without crashing devices."
        },
        {
            id: 4,
            title: "Prototyping & Rapid Iteration",
            icon: Procesimg4,
            text: "We can spin up prototypes quickly for user testing or client demos, helping you validate concepts and refine designs before full-scale development."
        },
        {
            id: 5,
            title: "Expertise in Leading AI Frameworks",
            icon: Procesimg5,
            text: "Whether it’s TensorFlow, PyTorch, or scikit-learn, we’ll help you pick the right tools and optimize your models for speed, accuracy, and scalability."
        },
        {
            id: 6,
            title: " Flexible Engagement Models",
            icon: Procesimg6,
            text: "Your needs can change fast, so let’s keep it flexible—whether that’s on-demand sprints or a quick consulting retainer. You stay in control of the pace and budget."
        },
        {
            id: 7,
            title: "Advanced Model Deployment & MLOps",
            icon: Procesimg7,
            text: "We streamline the CI/CD of ML models, automating retraining, versioning, and deployment to keep your AI solutions up to date with minimal downtime."
        },
        {
            id: 8,
            title: "White-Label or Co-Branded Services",
            icon: Procesimg8,
            text: "Want a seamless extension of your team? We can work behind the scenes under your brand—or co-brand with you—so your clients see one unified solution."
        },
        {
            id: 9,
            title: "On-Demand Engineering Capacity",
            icon: Procesimg9,
            text: "Got a sudden influx of projects or tight deadlines? We’re ready to jump in and provide the extra dev horsepower you need, exactly when you need it."
        },
        {
            id: 10,
            title: "Fast Turnarounds & Reliable Delivery",
            icon: Procesimg10,
            text: "Need something delivered yesterday? We understand tight timelines and pride ourselves on hitting deadlines without sacrificing quality"
        },
        {
            id: 11,
            title: "Founder-Friendly Collaboration",
            icon: Procesimg11,
            text: "We know early-stage life can be chaotic. We keep lines of communication open, adapt to changes on the fly, and work side by side as an extension of your team."
        },
        {
            id: 12,
            title: "Long-Term Partnership Mindset",
            icon: Procesimg12,
            text: "We’re not just about the one-off project. We aim to become your go-to dev resource, supporting your growth and ensuring you shine in front of your clients."
        },
        {
            id: 13,
            title: "Scalable Foundations",
            icon: Procesimg13,
            text: "We’ll set you up with a codebase and infrastructure that can grow with your user base, so you’re not stuck rebuilding when you land that big round."
        },
    ];

    // Calculate the height of the card on mount
    // useEffect(() => {
    //     if (cardRef.current) {
    //         const style = getComputedStyle(cardRef.current);
    //         const height = cardRef.current.offsetHeight;
    //         const marginBottom = parseInt(style.marginBottom, 20); // Get the gap value
    //         setCardHeight(225);
    //     }
    // }, []);
    useEffect(() => {
        if (cardRef.current) {
            const element = cardRef.current;
            const style = window.getComputedStyle(element);

            // Calculate offsetHeight + margins
            const totalHeight =
                element.offsetHeight +
                parseInt(style.marginTop || "0", 0) +
                parseInt(style.marginBottom || "0", 10);

            setCardHeight(totalHeight);
        }
    }, []);

    // Auto-scroll setup
    useEffect(() => {
        // startAutoScroll();

        return () => stopAutoScroll(); // Cleanup on component unmount
    }, [cardHeight]); // Restart auto-scroll when cardHeight updates

    // const startAutoScroll = () => {
    //     stopAutoScroll(); // Prevent multiple intervals
    //     intervalRef.current = setInterval(() => {
    //         setCurrentIndex((prevIndex) => {
    //             if (prevIndex + 2 >= processdata.length) {
    //                 return 0; // Reset to top when only 2 elements are left
    //             }
    //             return prevIndex + 1;
    //         });
    //     }, 2500); // Scroll every 3 seconds
    // };

    const stopAutoScroll = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    // Handlers for next and previous buttons
    // Handlers for next and previous buttons
    const handleNext = () => {
        setActiveButton('next');
        if (currentIndex + 2 >= processdata.length) {
            setCurrentIndex(0); // Scroll to top if only 2 elements are left
        } else {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
        // startAutoScroll(7000);
    };

    const handlePrevious = () => {
        setActiveButton('previous');
        setCurrentIndex((prevIndex) =>
            prevIndex <= 0 ? prevIndex : prevIndex - 1
        );
    };
    return (
        <section className='process-main' data-aos="fade-up">
            <div className="A-title" data-aos="fade-up" >
                <span>The Process</span>
                <h1>Our Commitment sets us apart where it matters</h1>
                <p className='title-text'>Our unwavering commitment is what distinguishes us, delivering excellence where it truly counts.</p>
                <a className='estimationbuttonlink' href="https://arttteo.com/contact">
                    <button className="estimation-button">
                        <p>Get your estimation</p>
                        <div className="arrow-circle">
                            <img src={rightarrow} alt="" />
                        </div>
                    </button>
                </a>
                <img className='titlearrow' src={titleArrow} alt="" />
            </div>

            <div className="process-right" data-aos="fade-up">
                <div className="process-content" style={{ transform: `translateY(-${currentIndex * cardHeight}px)` }}>
                    {processdata.map((item, index) => {
                        const ProcesLogo = item.icon;
                        return (
                            // Attach the ref only to the first card
                            <div className={`processcard ${currentIndex === index ? 'active' : ''}`} key={item.id} ref={index === 0 ? cardRef : null} >
                                <div className="logo-title">
                                    <div className="Procescircle">
                                        <ProcesLogo />
                                    </div>

                                    <h2>{item.title}</h2>
                                </div>
                                <p className='processcard-text'>{item.text}</p>
                            </div>
                        )
                    })}
                </div>
                <div className="process-buttons">
                    <button onClick={handlePrevious} className={activeButton === 'previous' ? 'active' : ''} ><FaArrowUpLong /></button>
                    <button onClick={handleNext} className={activeButton === 'next' ? 'active' : ''} ><FaArrowDownLong /></button>
                </div>
            </div>
            <div className="process-buttons responsivebuttons">
                <button onClick={handlePrevious} className={activeButton === 'previous' ? 'active' : ''} ><FaArrowUpLong /></button>
                <button onClick={handleNext} className={activeButton === 'next' ? 'active' : ''} ><FaArrowDownLong /></button>
            </div>
        </section>
    );
}

export default Process;